<template>
  <main>
    <b-table responsive striped hover :items="items" :fields="fields">

      <template #cell(downloadurl1)="data">
        <a target="_blank" :href="data.value" >Faktura</a>
      </template>

    </b-table>
  </main>
</template>
<script>
export default {
  name: 'balancetable',
  props: ['items'],
  data () {
    return {
      fields: [
        {
          label: 'Dato',
          key: 'invoicedate',
          sortable: true
        },
        {
          label: 'Beløb',
          key: 'total',
          sortable: true,
          variant: 'success'
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true
        },
        {
          key: 'invoice_desc',
          label: 'Beskrivelse',
          sortable: true,
          variant: 'success'
        },
        {
          key: 'downloadurl1',
          label: 'Se faktura',
          sortable: true
        }
      ]
    }
  }
}
</script>
<style>
  thead > tr > th {
    font-weight:  400;
    font-family:  'canada-type-gibson';
  }
</style>



// WEBPACK FOOTER //
// BalanceTable.vue?0900296e